import { LegalPageLayout } from './LegalPageLayout'

// Contenu déplacé depuis l'ancienne PrivacyModal (source unique, plus de modale).
export default function Confidentialite() {
  return (
    <LegalPageLayout title="Politique de confidentialité">
      <p className="italic text-sm">En vigueur au 17/04/2026</p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Article 1 : Préambule</h2>

      <p>
        La présente politique de confidentialité a pour but d'informer les utilisateurs du site <a href="https://www.lorenzcampan-ia.fr" className="text-accent hover:underline">https://www.lorenzcampan-ia.fr</a> :
      </p>

      <ul className="list-disc pl-5 space-y-1">
        <li>Sur la manière dont sont collectées leurs données personnelles ;</li>
        <li>Sur les droits dont ils disposent concernant ces données ;</li>
        <li>Sur la personne responsable du traitement des données à caractère personnel collectées et traitées ;</li>
        <li>Sur les destinataires de ces données personnelles.</li>
      </ul>

      <p>
        Cette politique complète les mentions légales consultables sur le site www.lorenzcampan-ia.fr.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Article 2 : Principes relatifs à la collecte et au traitement des données personnelles</h2>

      <p>
        Conformément à l'article 5 du Règlement européen 2016/679 (RGPD), les données à caractère personnel collectées sont traitées de manière licite, loyale et transparente, collectées pour des finalités déterminées et légitimes, adéquates et limitées à ce qui est nécessaire, exactes et tenues à jour, conservées pour une durée n'excédant pas celle nécessaire, et traitées de façon à garantir leur sécurité.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Article 3 : Données à caractère personnel collectées et traitées</h2>

      <h3 className="text-lg font-medium text-white mt-6 mb-3">Article 3.1 : Données collectées</h3>

      <p>
        Les données personnelles collectées dans le cadre de l'utilisation du site sont les suivantes :
      </p>

      <p><strong>Via le formulaire de contact :</strong></p>

      <ul className="list-disc pl-5 space-y-1">
        <li>Nom et prénom</li>
        <li>Adresse email</li>
        <li>Numéro de téléphone <em>(champ facultatif)</em></li>
        <li>Nom de l'entreprise <em>(champ facultatif)</em></li>
        <li>Message</li>
      </ul>

      <p>
        Ces données sont collectées pour la finalité suivante : <strong>traitement des demandes de contact et d'information</strong>, sur la base légale de l'<strong>intérêt légitime</strong> de l'éditeur (article 6.1.f du RGPD).
      </p>

      <h3 className="text-lg font-medium text-white mt-6 mb-3">Article 3.2 : Durée de conservation des données</h3>

      <p>
        Les données sont conservées pendant une durée de <strong>3 ans</strong> à compter du dernier contact. Au-delà de ce délai, elles sont supprimées ou anonymisées. Lorenz Campan est susceptible de conserver certaines données au-delà de ce délai afin de remplir ses obligations légales ou réglementaires.
      </p>

      <h3 className="text-lg font-medium text-white mt-6 mb-3">Article 3.3 : Hébergement des données</h3>

      <p>Le site www.lorenzcampan-ia.fr est hébergé par :</p>

      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Vercel Inc.</strong></li>
        <li>340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis</li>
        <li><strong>Site web :</strong> <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">https://vercel.com</a></li>
      </ul>

      <p className="text-sm border-l-2 border-white/20 pl-4 py-1 text-white/50 italic mt-4">
        <strong>Note sur les transferts hors UE :</strong> Vercel Inc. est une société américaine. Dans le cadre de l'hébergement du site, des données peuvent être traitées sur des serveurs situés en dehors de l'Union européenne. Ces transferts sont encadrés par les Clauses Contractuelles Types (CCT) adoptées par la Commission européenne, conformément à l'article 46 du RGPD.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Article 4 : Responsable du traitement des données</h2>

      <h3 className="text-lg font-medium text-white mt-6 mb-3">Article 4.1 : Le responsable du traitement</h3>

      <p>
        Les données à caractère personnel sont collectées par <strong>Lorenz Campan</strong>, entrepreneur individuel, dont le siège est situé au <strong>14 route du chêne vert 16600 Mornac</strong>.
      </p>

      <p>Le responsable du traitement peut être contacté :</p>

      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Par email :</strong> contact@lorenzcampan-ia.fr</li>
        <li><strong>Via le formulaire de contact</strong> disponible sur www.lorenzcampan-ia.fr</li>
      </ul>

      <h3 className="text-lg font-medium text-white mt-6 mb-3">Article 4.2 : Délégué à la protection des données</h3>

      <p>
        Aucun délégué à la protection des données (DPO) n'a été désigné, l'entreprise n'étant pas soumise à cette obligation.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Article 5 : Droits de l'utilisateur</h2>

      <p>Tout utilisateur dispose des droits suivants concernant ses données personnelles :</p>

      <ul className="list-disc pl-5 space-y-1">
        <li>Droit d'accès (article 15 du RGPD)</li>
        <li>Droit de rectification (article 16 du RGPD)</li>
        <li>Droit à l'effacement (article 17 du RGPD)</li>
        <li>Droit à la limitation du traitement (article 18 du RGPD)</li>
        <li>Droit à la portabilité des données (article 20 du RGPD)</li>
        <li>Droit d'opposition (article 21 du RGPD)</li>
      </ul>

      <p>Pour exercer ces droits, l'utilisateur peut contacter Lorenz Campan :</p>

      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Par email :</strong> contact@lorenzcampan-ia.fr</li>
        <li><strong>Via le formulaire de contact</strong> disponible sur www.lorenzcampan-ia.fr</li>
      </ul>

      <p>
        Lorenz Campan s'engage à répondre dans un délai maximum d'<strong>1 mois</strong> suivant la réception de la demande (article 12 du RGPD).
      </p>

      <p>
        En cas de désaccord, l'utilisateur peut adresser une réclamation à la Commission Nationale de l'Informatique et des Libertés (CNIL) — <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">www.cnil.fr</a>.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Article 6 : Cookies</h2>

      <p>
        Le site www.lorenzcampan-ia.fr est susceptible d'utiliser des cookies techniques strictement nécessaires au bon fonctionnement du service. Ces cookies sont exemptés de consentement conformément aux recommandations de la CNIL.
      </p>

      <p className="text-sm border-l-2 border-white/20 pl-4 py-1 text-white/50 italic mt-4">
        <strong>Note :</strong> Si des outils d'analyse d'audience (type Vercel Analytics ou équivalent) venaient à être activés sur ce site, la présente politique serait mise à jour en conséquence et un bandeau de consentement aux cookies serait mis en place.
      </p>

      <p>Aucun cookie analytique, publicitaire ou de tracking tiers n'est actuellement utilisé.</p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Article 7 : Modification de la politique de confidentialité</h2>

      <p>
        Lorenz Campan se réserve le droit de modifier la présente politique de confidentialité à tout moment. L'utilisateur est invité à la consulter régulièrement. La date de mise en vigueur figurant en tête de page est mise à jour à chaque modification substantielle.
      </p>
    </LegalPageLayout>
  )
}
